module.exports = __webpack_public_path__ + "static/front-fa356e4ebf7ff7f07a266c6ca59ececd.jpg";